<div *ngIf="openDocuments" class="summary-card">
  <div class="summary-card-content">
    <div class="summary-card-header">
      <div>
        <h5>{{ "DOCUMENTS.ATTACH_DOCUMENTS" | translate }}:</h5>
      </div>
    </div>
    <div class="container-card-body">
      <div class="description d-none d-md-block">
        {{ "DOCUMENTS.UPLOAD_DOCUMENTS_DESCRIPTION_ISF" | translate }}
      </div>
      <div class="description d-md-none">
        {{ "DOCUMENTS.UPLOAD_DOCUMENTS_DESCRIPTION_ISF_MOBILE" | translate }}
      </div>

      <div class="mb-2" *ngFor="let document of attachedDocuments; let index = index">
        <isf-document-upload
          [id]="'isf-documents-' + isf.id + '-' + index + (document.id ? '-' + document.id : '')"
          [isCanUploadDocuments]="isCanUploadDocuments"
          [document]="document"
          [isCanRemoveDocuments]="isCanRemoveDocuments"
          [upload]="onUploadDocument()"
          [remove]="onRemoveDocument()"
          (stateUpdate)="onDocumentStateUpdate(document.id, $event)"
        ></isf-document-upload>
      </div>

      <document-add-other
        *ngIf="isCanUploadDocuments"
        [createDocument]="createDocumentTemplate"
        [includesTypes]="includesTypes"
        [upload]="onUploadDocument()"
      ></document-add-other>

      <button
        class="btn btn-link d-block mt-2"
        type="button"
        *ngIf="isUploadedAnyFiles && !isHideDownloadAll"
        (click)="onDownloadAllFiles()"
      >
        <i class="fa fa-download" aria-hidden="true"></i>
        <span>
          {{ "LABELS.DOWNLOAD_ALL_FILES" | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
